"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.company.list': 'Aziende',
    'route.company.create': 'Aggiungi Azienda',
    'route.company.edit': 'Modifica Azienda',
};
